import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import { IVideo } from "../model/interface/video";
import { getJoinedStringByItem } from "../utils/reusedFunctions";
import { AxiosResponse } from "axios";

export const getStandardVideos = (standardId: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STANDARDVIDEO, {
    params: {
      standardId: standardId,
    },
  });
};
export const getVideos = (video: IVideo) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_VIDEOALL, {
    params: {
      pageSize: video.pageSize,
      pageNumber: video.pageNumber,
      standardId: video.standardId,
      standardName: video.standardName,
      videoid: video.videoId,
      videoUrl: video.videoUrl,
      title: video.title,
      isApproved: video.isApproved,
      isActive: video.isActive,
      orderbyColumn: video.orderbyColumn,
      sortDir: video.sortDir,
      tagIds: video.videoTags,
      contentAreaId: video.contentAreaId,
      gradeLevelId: video.gradeLevelId,
    },
  });
};

export const addVideo = (video: any): Promise<AxiosResponse> => {
  return AxiosHelper.axiosInstance().post(APIConstant.CMS_VIDEO, video, {});
};

export const updateVideo = (video: any) => {
  return AxiosHelper.axiosInstance().put(APIConstant.CMS_VIDEO, video, {});
};

export const deleteVideo = (videoId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_VIDEO, {
    params: {
      id: videoId,
    },
  });
};
export const getVideo = (videoId: number) => {
  return AxiosHelper.axiosInstance().get<IVideo>(
    `${APIConstant.CMS_VIDEO_DETAIL}/${videoId}`,
    {}
  );
};

export const getVideoQuestions = (questionData) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_ALL, {
    params: {
      SubjectId: questionData.subjectId,
      GradeId: questionData.gradeId,
      DomainId: questionData.domainId,
      StandardId: questionData.standardId,
      QuestionIds: questionData.questionIds.toString(),
      QuestionTypeIds: getJoinedStringByItem(questionData.questionTypeId),
      orderbyColumn: "questionId",
      sortDir: questionData.sortByDesc,
      pageSize: questionData.pageSize,
      pageNumber: questionData.pageNumber,
      IsPublished: questionData.isPublished,
      IsDiagnostics: questionData.isDiagnostics,
      isVideoLesson: questionData.isVideoLesson,
      isConstructedResponse: questionData.isConstructedResponse,
      IsActive: questionData.isActive,
      DestinationVideoId: questionData.destinationVideoId
        ? questionData.destinationVideoId
        : 0,
      CreatedByUserId: questionData.createdByUserId,
      QuestionText: questionData.questionText,
    },
  });
};

export const getAssociateVideoQuestions = (videoId, pageNumber?, pageSize?) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_QUESTION_ALL, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
    params: {
      VideoId: videoId,
      OrderByColumn: "QuestionId",
      IsActive: true,
      SortDir: "Asc",
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const postVideoQuestion = (questionData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_VIDEOPOSTQUESTION,
    questionData,
    {
      headers: {
        "x-requested-with": "XMLHttpRequest",
      },
    }
  );
};

export const deleteVideoAssociateQuestion = (
  videoId,
  questionId,
  userId,
  englishQuestionRefId,
  spanishQuestionRefId,
  englishVideoRefId,
  spanishVideoRefId
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_VIDEODELETEQUESTION,
    {
      data: {
        videoId: videoId,
        questionId: questionId,
        userId: userId,
        englishQuestionReferenceId: englishQuestionRefId,
        spanishQuestionReferenceId: spanishQuestionRefId,
        englishVideoReferenceId: englishVideoRefId,
        spanishVideoReferenceId: spanishVideoRefId,
      },
    }
  );
};
export const getAssociateVideoByQuestionId = (questionId, userId) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_VIDEO_BY_QUESTION_ID, {
    headers: {
      "x-requested-with": "XMLHttpRequest",
    },
    params: {
      questionId: questionId,
      userId: userId,
    },
  });
};

export const postVideoTag = (Tag) => {
  return AxiosHelper.axiosInstance().post(APIConstant.CMS_VIDEOTAG, Tag, {});
};

export const deleteVideoTag = (tag) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_VIDEOTAG, {
    params: tag,
  });
};

export const getStandardsByVideoId = (
  videoId: number,
  pageSize: number,
  pageNumber: number,
  columnName: string,
  sortDir: string
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STANDARD_BY_VIDEO, {
    params: {
      videoId: videoId,
      pageSize: pageSize,
      pageNumber: pageNumber,
      orderbyColumn: columnName,
      sortDir: sortDir,
    },
  });
};

export const unassociateVideoStandards = (
  videoId: number,
  standardIds: Array<number>
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_VIDEO_UNASSOCIATE_STANDARDS,
    {
      data: {
        videoId,
        standardIds,
      },
    }
  );
};
export const uploadThumbnail = (request) => {
  return AxiosHelper.axiosInstance().post<Array<string>>(
    APIConstant.CMS_VIDEO_THUMBNAIL_UPLOAD,
    {
      videoThumbnailBase64Files: request.videothumbnailFiles,
      type: request.type,
      videoExternalId: request.videoExternalId,
    }
  );
};
